import { __awaiter, __decorate, __metadata } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ObservableController, observe, unobserve, } from '@smoovy/observer';
import { Resolver } from '@smoovy/utils';
let ObservableRoot = class ObservableRoot extends LitElement {
    constructor() {
        super(...arguments);
        this.resolver = new Resolver();
        this.name = 'default';
        this.resize = true;
        this.useRoot = false;
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            if (!this.controller) {
                this.controller = new ObservableController({
                    resizeObserver: this.resize,
                    intersectionObserver: {
                        threshold: this.threshold,
                        rootMargin: this.margin,
                        root: this.useRoot ? this : undefined
                    }
                });
            }
            setTimeout(() => {
                if (!this.resolver.completed) {
                    this.resolver.resolve();
                }
            });
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    get ready() {
        return this.resolver.promise;
    }
    observe(element) {
        return observe(element, this.controller);
    }
    unobserve(observable) {
        return unobserve(observable, this.controller);
    }
    render() {
        return html `<slot></slot>`;
    }
};
ObservableRoot.styles = css `:host { display: block; }`;
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ObservableRoot.prototype, "name", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ObservableRoot.prototype, "margin", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], ObservableRoot.prototype, "threshold", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], ObservableRoot.prototype, "resize", void 0);
__decorate([
    property({ type: Boolean, attribute: 'use-root' }),
    __metadata("design:type", Object)
], ObservableRoot.prototype, "useRoot", void 0);
ObservableRoot = __decorate([
    customElement(`djx-observable-root`)
], ObservableRoot);
export { ObservableRoot };
//# sourceMappingURL=root.js.map